import React from 'react';
import './Clubs.css';
import Image1 from '../../assets/club/BUEDF.png';
import Image2 from '../../assets/club/ROBU.png';
import Image3 from '../../assets/club/BUCC.png';

const data = [
  {
    id: 1,
    image: Image1,
    title: "BRAC University Entrepreneurship Development Forum (BUEDF)",
    role: "Senior Executive of IT",
    details:
      "Contributed to organizing IT-related events and managing technical operations. Duration: March 2022 - November 2023.",
  },
  {
    id: 2,
    image: Image2,
    title: "BRAC University Robotics Club (ROBU)",
    role: "Apprentice of Finance and Management Department",
    details:
      "Engaged in robotics projects while managing financial and administrative responsibilities. Duration: March 2022 - July 2023.",
  },
  {
    id: 3,
    image: Image3,
    title: "BRAC University Computer Club (BUCC)",
    role: "Member of Event Management",
    details:
      "Actively participated in club activities, contributing to event planning and technical projects. Duration: October 2021 - December 2023.",
  },
];

const Services = () => {
  return (
    <section className="services container section" id="services">
      <h2 className="section__title">Extracurricular Activities</h2>

      <div className="services__container grid">
        {data.map(({ id, image, title, role, details }) => (
          <div className="services__card" key={id}>
            <img src={image} alt={title} className="services__img" />
            <h3 className="services__title">{title}</h3>
            <p className="services__role"><strong>{role}</strong></p>
            <p className="services__description">{details}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
